import React, { Fragment } from "react";

import { groupMedicationsByLetter } from "../../helpers/groupByLetter";
import MedicationByLetter from "./MedicationByLetter";

const DiseaseList = ({ letter, results }) => {
  // Group funds by starting letter
  const groupedMeds = groupMedicationsByLetter(results);

  const showLetter = entry => {
    return (
      !letter || (letter && entry.letter.toLowerCase() === letter.toLowerCase())
    );
  };

  return (
    <div className="l-padding">
      <div className="l-wrap">
        <Fragment>
          {groupedMeds && groupedMeds.map((entry, i) => (
            <Fragment key={i}>
              {showLetter(entry) && (
                <MedicationByLetter
                  key={i}
                  letter={entry.letter}
                  medications={entry.items}
                />
              )}
            </Fragment>
          ))}
        </Fragment>
      </div>
    </div>
  );
};

export default DiseaseList;
